import { render, staticRenderFns } from "./ExamPublish.vue?vue&type=template&id=7b20f769&scoped=true"
import script from "./ExamPublish.ts?vue&type=script&lang=ts&external"
export * from "./ExamPublish.ts?vue&type=script&lang=ts&external"
import style0 from "./ExamPublish.vue?vue&type=style&index=0&id=7b20f769&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b20f769",
  null
  
)

export default component.exports